import { fromEntries } from "./browserCompat";
function cloneValue(value) {
  if (Array.isArray(value)) return value.map(cloneValue);
  if (!value || typeof value !== "object") return value;
  return fromEntries(Object.entries(value).map(([key, item]) => [key, cloneValue(item)]));
}
function isObject(value) { return Boolean(value) && typeof value === "object" && !Array.isArray(value); }
function mergeDeep(base, override) {
  if (!isObject(base)) return cloneValue(override === undefined ? base : override);
  const out = cloneValue(base);
  if (!isObject(override)) return out;
  for (const [key, value] of Object.entries(override)) {
    out[key] = isObject(value) && isObject(out[key]) ? mergeDeep(out[key], value) : cloneValue(value);
  }
  return out;
}

const social = (iconColor) => Object.freeze({
  iconColor,
  backgroundColor: "transparent",
  borderColor: "transparent",
  borderWidth: 0,
  borderRadius: 999,
  hoverIconColor: iconColor,
  hoverBackgroundColor: "rgba(0,0,0,.04)",
  hoverBorderColor: "transparent",
  focusRingColor: iconColor,
  sizeMobile: 31,
  sizeDesktop: 38,
});

export const CONTACT_PAGE_STYLE_DEFAULTS = Object.freeze({
  background: Object.freeze({
    color: "#19242F",
    imageUrl: "",
    imagePosition: "center",
    overlayEnabled: true,
    overlayStartColor: "#19242F",
    overlayEndColor: "#F35A3A",
    overlayAngle: 135,
  }),
  surface: Object.freeze({ backgroundColor: "rgba(255,255,255,.96)", borderColor: "transparent", borderWidth: 0, borderRadius: 32, boxShadow: "0 24px 70px rgba(0,0,0,.28)" }),
  title: Object.freeze({ color: "#19242F" }),
  subtitle: Object.freeze({ color: "#5B5D73" }),
  map: Object.freeze({ backgroundColor: "#EEF0F5", borderColor: "transparent", borderWidth: 0, borderRadius: 24, boxShadow: "0 8px 28px rgba(0,0,0,.16)" }),
  address: Object.freeze({ textColor: "#1A1A2E", iconColor: "#F35A3A" }),
  phone: Object.freeze({ textColor: "#1A1A2E", iconColor: "#1A1A2E", hoverTextColor: "#1A1A2E", focusRingColor: "#F35A3A" }),
  email: Object.freeze({ textColor: "#1A1A2E", iconColor: "#1A1A2E", hoverTextColor: "#1A1A2E", focusRingColor: "#F35A3A" }),
  schedule: Object.freeze({ textColor: "#5B5D73", iconColor: "#5B5D73" }),
  socials: Object.freeze({
    instagram: social("#d62976"),
    facebook: social("#1877F2"),
    whatsapp: social("#25D366"),
  }),
});

export function materializeContactPageVisualOwnership(input = {}) {
  const source = cloneValue(input || {});
  const existingStyle = source?.pages?.contact?.style;
  let style;
  if (isObject(existingStyle)) {
    style = mergeDeep(CONTACT_PAGE_STYLE_DEFAULTS, existingStyle);
  } else {
    style = cloneValue(CONTACT_PAGE_STYLE_DEFAULTS);
    const legacyImage = String(source?.contact?.backgroundImageUrl || "").trim();
    const legacyPosition = String(source?.contact?.backgroundImagePosition || "").trim();
    if (legacyImage) style.background.imageUrl = legacyImage;
    if (legacyPosition) style.background.imagePosition = legacyPosition;
  }
  source.pages = isObject(source.pages) ? source.pages : {};
  source.pages.contact = isObject(source.pages.contact) ? source.pages.contact : {};
  source.pages.contact.style = style;
  return source;
}
